"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  url: '/test',
  label: '555 555 0000',
  priority: 'lowIcon',
  ctaTheme: 'light',
  openNewTab: false,
  roleTab: false,
  icon: 'Phone',
  customImage: {},
  classes: ['isButton']
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;